import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import {
  Location,
  Document,
  Menu as IconMenu,
  Setting,
} from '@element-plus/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isCollapse = ref(true)
const handleOpen = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}
const handleClose = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_radio_group, {
      modelValue: isCollapse.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isCollapse).value = $event)),
      style: {"margin-bottom":"20px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_button, { label: false }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("expand")
          ])),
          _: 1
        }),
        _createVNode(_component_el_radio_button, { label: true }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("collapse")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_menu, {
      "default-active": "2",
      class: "el-menu-vertical-demo",
      collapse: isCollapse.value,
      onOpen: handleOpen,
      onClose: handleClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_sub_menu, { index: "1" }, {
          title: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Location))
              ]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Navigator One", -1))
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item_group, null, {
              title: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("span", null, "Group One", -1)
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "1-1" }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("item one")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "1-2" }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("item two")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item_group, { title: "Group Two" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "1-3" }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("item three")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "1-4" }, {
              title: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("span", null, "item four", -1)
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "1-4-1" }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("item one")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "2" }, {
          title: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("Navigator Two")
          ])),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(IconMenu))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, {
          index: "3",
          disabled: ""
        }, {
          title: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("Navigator Three")
          ])),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Document))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "4" }, {
          title: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode("Navigator Four")
          ])),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Setting))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["collapse"])
  ], 64))
}
}

})